<template>
  <div class="appdesc">
    <h3>
      <img v-if="app.iconUrl" :src="app.iconUrl" width="32" height="32" />
      <img v-if="app.iconDataBase64" :src="iconDataBase64Url" width="32" height="32" />
      <router-link v-if="app.routerlink" :to="`/app/${app.name}`">{{ app.name }}</router-link>
      <a v-else-if="app.webpage" :href="app.webpage">{{app.name}}</a>
      <span v-else>{{app.name}}</span>
    </h3>
    <div>
      <p id="version">v{{ app.version }}</p>
      <p>{{ app.onelinedesc }}</p>
    </div>
  </div>
</template>

<style scoped>
h1 {
  text-align: center;
}
h3 {
  margin: 0%;
  padding: 0%;
  border: 0px;
  /* background-color: blue; */
}

div.appdesc {
  background-color: beige;
}
div.appinfo {
  max-width: 480px;
}
</style>

<script>
export default {
  name: "AppComponent",
  props: ["app"],
  data() {
    return {
      a: 1
    };
  },
  beforeCreate() {
    // At this time, |this.apps| is not defined
    // console.log(this.apps)
    // console.log("GitApp:beforeCreate")
  },
  created() {
    // console.log(this.apps)
    // console.log("GitApp:created")
  },
  mounted() {
    // console.log(this.apps)
  },
  computed: {
    iconDataBase64Url() {
      return 'data:image/ico;base64,' + this.app.iconDataBase64;
    }
  }
};
</script>


